import { collateralTypeToDescription } from '../logic/collateralization'
import { PositionOverview } from '../logic/types'
import { Token } from '@/domain/types/Token'
import { SparkRewardCampaign, SparkRewardPill } from '@/ui/molecules/spark-reward-pill/SparkRewardPill'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

export interface DepositOverviewPanelProps {
  depositAsset: Token
  currentPositionOverview: PositionOverview
  updatedPositionOverview?: PositionOverview
  relatedCampaigns: SparkRewardCampaign[]
}
export function DepositOverviewPanel({
  depositAsset,
  currentPositionOverview,
  updatedPositionOverview,
  relatedCampaigns,
}: DepositOverviewPanelProps) {
  return (
    <TransactionOverview>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Supply APY</TransactionOverview.Label>
        <TransactionOverview.ApyChange
          currentApy={currentPositionOverview.supplyAPY}
          updatedApy={updatedPositionOverview?.supplyAPY}
          colorUpdated={false}
          currentApyTestId={testIds.dialog.deposit.supplyApyBefore}
          updatedApyTestId={testIds.dialog.deposit.supplyApyAfter}
        />
      </TransactionOverview.Row>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Supplied</TransactionOverview.Label>
        <TransactionOverview.TokenAmountChange
          token={depositAsset}
          currentAmount={currentPositionOverview.supplied}
          updatedAmount={updatedPositionOverview?.supplied}
        />
      </TransactionOverview.Row>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Collateralization</TransactionOverview.Label>
        <TransactionOverview.Generic>
          {collateralTypeToDescription(currentPositionOverview.collateralization)}
        </TransactionOverview.Generic>
      </TransactionOverview.Row>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Health factor</TransactionOverview.Label>
        <TransactionOverview.HealthFactorChange
          currentHealthFactor={currentPositionOverview.healthFactor}
          updatedHealthFactor={updatedPositionOverview?.healthFactor}
        />
      </TransactionOverview.Row>
      {relatedCampaigns.length > 0 && (
        <TransactionOverview.Row>
          <TransactionOverview.Label>Extra Rewards</TransactionOverview.Label>
          <TransactionOverview.Generic>
            {relatedCampaigns.map((campaign) => (
              <SparkRewardPill key={campaign.campaignId} {...campaign} />
            ))}
          </TransactionOverview.Generic>
        </TransactionOverview.Row>
      )}
    </TransactionOverview>
  )
}
